function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconZipRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 7H16l-1.37-2.86A2 2 0 0012.83 3H5.51a2 2 0 00-1.92 1.45L2 10v17a2 2 0 002 2h24a2 2 0 002-2V9a2 2 0 00-2-2zm0 20H4V10.28L5.51 5h7.32l1.37 2.86.54 1.14H28v18z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23 22.4v-1.1l3.69-5.17H8.34V14.7h5.71v1.11L10.35 21h3.84v1.4H8.23zM15.27 22.4v-7.7h1.63v7.7h-1.63zM18.68 22.4v-7.7h2.59a3.848 3.848 0 011.61.31 2.43 2.43 0 011.12.89 2.81 2.81 0 010 2.82c-.265.396-.64.706-1.08.89a3.851 3.851 0 01-1.61.32h-1v2.47h-1.63zm2.5-6.28h-.88v2.38h.88a2 2 0 001.08-.28 1 1 0 00.41-.91 1 1 0 00-.41-.91 1.88 1.88 0 00-1.08-.28z",
    fill: props.color
  }));
}

export default SvgIconZipRexOutline;